/**
 * GENERATED CODE - DO NOT MODIFY
 */
import { Headers, XRPCError } from '@atproto/xrpc'
import { ValidationResult, BlobRef } from '@atproto/lexicon'
import { isObj, hasProp } from '../../../../util'
import { lexicons } from '../../../../lexicons'
import { CID } from 'multiformats/cid'

export interface QueryParams {}

export interface InputSchema {
  /** The unique actionId of the claim. */
  actionId: string
  /** The transaction id of the claim. */
  txId?: string
  /** The time in seconds since the epoch. */
  timeSec?: number
  [k: string]: unknown
}

export interface OutputSchema {
  /** The actionId of the claim that was updated. */
  actionId: string
  /** The uri of the claim that was updated. */
  uri: string
  /** The cid of the claim that was updated. */
  cid: string
  [k: string]: unknown
}

export interface CallOptions {
  headers?: Headers
  qp?: QueryParams
  encoding: 'application/json'
}

export interface Response {
  success: boolean
  headers: Headers
  data: OutputSchema
}

export function toKnownErr(e: any) {
  if (e instanceof XRPCError) {
  }
  return e
}
